<template>
  <Wrapper>
    <Topo logado />
    <MenuLateral />
    <InternaMain class="padding-b" maxwidth-container="810px">
      <Loading v-if="loading" />
      <ErrorServidor v-else-if="erro" />
      <template v-else>
        <TituloPagina
          :titulo="tituloDaPagina"
          class="mt-5 mt-md-11"
        />

        <p
          class="pa-0 mt-5 mb-0 primary--text"
          data-cy="texto_da_pagina"
        >
          Cadastre cartões de crédito e facilite na hora de realizar seus
          pagamentos com o Minhas Compras Monetizze!
        </p>

        <template v-if="listaCartoes.length > 0">
          <template v-if="loadingLista">
            <v-skeleton-loader
              v-for="n in quantCartoesLoading"
              :key="n"
              transition="transition"
              type="list-item-avatar-three-line"
              class="mt-6"
              loading
            />
          </template>
          <ListaCartoes
            v-else
            :lista="listaCartoes"
            @excluirCartao="excluirCartao($event)"
            @setCartaoPrincipal="setCartaoPrincipal"
          />
        </template>

        <template v-else>
          <v-img
            :alt="imgAlt"
            :src="require(`@/assets/img/${imgSrc}`)"
            :height="imgHeight"
            :width="imgWidth"
            class="mt-8 mx-md-auto"
          />
        </template>

        <div
          :class="[
            $vuetify.breakpoint.mdAndUp
              ? 'botoes-rodape--desktop' : 'botoes-rodape--mobile',
            $vuetify.breakpoint.mdAndUp && listaCartoes.length < 1
              ? 'botoes-rodape--menor mx-md-auto' : '',
          ]"
          class="grey lighten-3 botoes-rodape pa-3 px-md-0 mt-md-12"
        >
          <v-btn
            :class="$vuetify.breakpoint.mdAndUp ? 'btn-desktop' : 'btn-mobile'"
            color="primary"
            outlined
            exact
            data-cy="btn_voltar"
            :to="linkBtn"
          >
            Voltar
          </v-btn>

          <v-btn
            :class="$vuetify.breakpoint.mdAndUp ? 'btn-desktop' : 'btn-mobile'"
            color="primary"
            to="/meu-perfil/cartoes-credito/cadastrar"
            data-cy="btn_novo_cartao"
            :disabled="desabilitarCadastro"
          >
            Novo cartão
          </v-btn>
        </div>

        <SnackBar
          :mensage="snackBar.message"
          :snackbar="snackBar.show"
          :button="true"
          :color="snackBar.color"
          :timeout="snackBar.timeout"
          @changeSnackBar="value => this.snackBar.show = value.visible"
        />
      </template>
    </InternaMain>
  </Wrapper>
</template>

<script>

import ApiMeuPerfil from '@/api/meuPerfil';
import InternaMain from '@/components/InternaMain.vue';
import Loading from '@/components/Loading.vue';
import Wrapper from '@/components/Wrapper.vue';
import Topo from '@/components/Topo.vue';
import MenuLateral from '@/components/MenuLateral.vue';
import TituloPagina from '@/components/TituloPagina.vue';
import ErrorServidor from '@/components/ErrorServidor.vue';
import ListaCartoes from '@/components/MeuPerfil/CartoesCredito/ListaCartoes.vue';
import SnackBar from '@/components/SnackBar.vue';

export default {
  name: 'CartoesCredito',

  components: {
    Wrapper,
    Topo,
    MenuLateral,
    InternaMain,
    TituloPagina,
    ErrorServidor,
    Loading,
    ListaCartoes,
    SnackBar,
  },

  beforeRouteEnter(to, from, next) {
    if (from.name === 'detalhe-compra') {
      return next((vm) => {
        vm.setBtnVoltar(from.params);
      });
    }

    return next();
  },

  data() {
    return {
      erro: false,
      imgAlt: 'Imagem ilustrativa para cadastre seu cartão de crédito.',
      imgHeight: '174',
      imgSrc: 'cartoes-credito.svg',
      imgWidth: '280',
      listaCartoes: {},
      loading: true,
      tituloDaPagina: 'Cartões de crédito',
      loadingLista: false,
      quantCartoesLoading: 1,
      snackBar: {
        message: '',
        color: 'success',
        timeout: 6000,
        show: false,
      },
      snackBarMensagens: {
        errorPadrao: 'Tente novamente mais tarde.',
        sucessoExcluir: 'Cartão excluído',
      },
      btnVoltar: '',
    };
  },

  computed: {
    desabilitarCadastro() {
      return this.listaCartoes.length >= 4;
    },

    linkBtn() {
      if (this.btnVoltar === '') return '/meu-perfil';
      return `/minhas-compras/detalhe-compra/${this.btnVoltar}`;
    },
  },

  created() {
    this.getListaCartoes(true);
  },

  methods: {
    excluirCartao(idCartao) {
      this.loadingLista = true;
      this.quantCartoes(true);

      ApiMeuPerfil.creditCardDelete(idCartao)
        .then(() => {
          this.getListaCartoes(false, true);
        })
        .catch((error) => {
          const { data } = error.response;
          const errorMessage = data.show ? data.error : this.snackBarMensagens.errorPadrao;
          this.setSnackbar(errorMessage, 'error');
          this.loadingLista = false;
        });
    },

    getListaCartoes(pagina = false, lista = false) {
      if (pagina) this.loading = true;
      if (lista) this.loadingLista = true;
      this.quantCartoes(true);

      ApiMeuPerfil.creditCardList()
        .then((response) => {
          this.listaCartoes = response.data;
          if (lista) {
            this.setSnackbar(this.snackBarMensagens.sucessoExcluir);
          }
        })
        .catch(() => {
          this.erro = true;
        })
        .finally(() => {
          if (pagina) this.loading = false;
          if (lista) this.loadingLista = false;
        });
    },

    setCartaoPrincipal(index, id) {
      this.loadingLista = true;
      this.quantCartoes();

      ApiMeuPerfil.creditCardMain(id)
        .then(() => {
          this.listaCartoes.forEach((itemLista) => {
            const item = itemLista;
            item.is_main = false;
          });
          this.listaCartoes[index].is_main = true;
        })
        .catch((error) => {
          const { data } = error.response;
          const errorMessage = data.show ? data.error : this.snackBarMensagens.errorPadrao;
          this.setSnackbar(errorMessage, 'error');
        })
        .finally(() => {
          this.loadingLista = false;
        });
    },

    quantCartoes(menosUm = false) {
      if (menosUm) {
        this.quantCartoesLoading = (this.listaCartoes.length <= 2)
          ? 1
          : this.listaCartoes.length - 1;
      } else {
        this.quantCartoesLoading = this.listaCartoes.length;
      }
    },

    setSnackbar(mensagem, status = 'success', timeout = 6000) {
      this.snackBar.message = mensagem;
      this.snackBar.color = status;
      this.snackBar.timeout = timeout;
      this.snackBar.show = true;
    },

    setBtnVoltar(value) {
      if (value.compraId) {
        this.btnVoltar = value.compraId;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/scss/botoes-fixos.scss';
</style>
